<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd"
         style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4"
                class="search-nav-left">
          <i class="el-icon-search"
             style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20"
                class="search-nav-right">
          <el-button class="search-open-close"
                     type="text"
                     @click="hide=!hide"
                     v-show="hide">收起查询</el-button>
          <el-button class="search-open-close"
                     type="text"
                     @click="hide=!hide"
                     v-show="!hide">展开查询</el-button>
          <i v-if="hide === true"
             class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false"
             class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new"
                     type="primary"
                     size="small"
                     @click="searchLoad">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide"
             class="search-content common-search-formtype">
          <el-form :inline="true"
                   :model="formInlineTmp"
                   label-width="95px"
                   class="search-content-item">
            <el-form-item label="活动名称：">
              <el-input @keyup.enter.native="searchLoad"
                        v-model.trim="formInlineTmp.name"
                        placeholder="请输入活动名称"
                        clearable></el-input>
            </el-form-item>

            <el-form-item label="活动时间：">
              <el-date-picker v-model="searStartEnd"
                              class="micro-page-picker"
                              style="width:350px!important;margin-top: 12px"
                              type="datetimerange"
                              range-separator="至"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              format="yyyy-MM-dd HH:mm"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </el-form-item>

          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top"
            style="padding-right:0">
      <el-col :span="4"
              style="text-align: left;">
        <i class="el-icon-document"
           style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20"
              class="text-align-right">
        <el-button type="primary"
                   v-if="butsObj.add"
                   @click="openDialog('add')"
                   class="add-btn btn-right"
                   style="float: right;">新建</el-button>
      </el-col>
    </el-row>

    <el-row class="import-data-title table-first-style">
      <el-table :data="tableData"
                v-loading="loading"
                class="table">
        <template slot="empty">
          <div class="newTableEmpty">暂无数据，去<span  @click="openDialog('add')">新建</span></div>
        </template>
        <el-table-column prop="name"
                         label="活动名称">
        </el-table-column>

        <el-table-column label="活动描述"
                         prop="remark">
        </el-table-column>

        <el-table-column label="中奖几率(%)">
          <template slot-scope="scope">
            {{ scope.row.winRate }}
          </template>
        </el-table-column>

        <el-table-column label="开始时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.beginTime }}
          </template>
        </el-table-column>
        <el-table-column label="结束时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.endTime }}
          </template>
        </el-table-column>

        <el-table-column label="活动链接"
                         width="600px">
          <template slot-scope="scope">
            <div :class="'class'+scope.row.id"
                 class="op-link"
                 @click="copyText(scope.row.id)">
              {{ scope.row.activityUrl }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作"
                         width="140">
          <template slot-scope="scope">
            <div class="op-link editColor"
                 v-if="butsObj.edit"
                 @click="openDialog('edit', scope.row)">
              编辑
            </div>
            <div class="op-link deleteColor"
                 v-if="butsObj.del"
                 @click="deleteAction(scope.row.id)">
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination"
                       background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :page-size="limit"
                       layout="total, prev, pager, next, jumper"
                       :total="totalCount">
        </el-pagination>
      </div>

    </el-row>

    <!--添加弹窗-->
    <el-dialog class="cellDialog base-dialog"
               :title="addForm.id ? '编辑活动': '添加活动'"
               :visible.sync="adddialog"
               width="700px">
      <el-form ref="addForm"
               :model="addForm"
               :rules="rules">
        <el-form-item label="活动名称:"
                      :label-width="addLabelWidth"
                      prop="name">
          <el-input class="stockInput"
                    type="text"
                    v-model="addForm.name"
                    auto-complete="off"
                    placeholder="输入活动名称"></el-input>
        </el-form-item>

        <el-form-item label="中奖几率:"
                      prop="winRate"
                      :label-width="addLabelWidth">
          <el-input class="stockInput"
                    v-model="addForm.winRate"
                    auto-complete="off"
                    type="number"
                    maxlength="3"
                    placeholder="输入中奖几率(%)"></el-input>
        </el-form-item>

        <el-form-item prop="startEnd"
                      :label-width="addLabelWidth"
                      class="start-end-time"
                      label="起止时间:"
                      style="margin-top: 5px;">
          <el-date-picker v-model="startEnd"
                          type="datetimerange"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          format="yyyy-MM-dd HH:mm"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :default-time="['00:00:00', '23:59:59']"
                          style=" ">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="APPID："
                      :required="true"
                      :label-width="addLabelWidth">
          <el-select v-model="addForm.appId"
                     clearable
                     placeholder="请选择APPID">
            <el-option v-for="item in publicNumberList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="活动描述:"
                      :label-width="addLabelWidth"
                      prop="remark">
          <el-input type="textarea"
                    v-model="addForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="margin-top: 10px">
        <el-button class="dialog-cancel-btn"
                   @click="adddialog = false"
                   style="margin-left: 20px">取 消</el-button>
        <el-button :disabled="disabled"
                   class="dialog-confirm-btn"
                   style="margin-right: 32px"
                   type="primary"
                   @click="saveWay()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { deleteNimbleCode } from '@/api/analyse.js'
import { butonsList, getMenId } from '@/api/analyse.js'
import { getVideoActivitys, createVideoActivitys, editVideoActivitys, deleteVideoActivitys, publicNumber } from '@/api/video-activity.js'
export default {
  name: 'activityVideoList',
  data () {
    var checkWinRate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('中奖几率不能为空'))
      }
      // console.log('typeof value', value, typeof value)
      if (Number(value) > 100 || Number(value) < 0) {
        callback(new Error('中奖几率有误'))
      }
      callback()
    }
    var that = this
    var checkStartEnd = (rule, value, callback) => {
      if (!that.startEnd) {
        return callback(new Error('活动时间不能为空'))
      }
      console.log('typeof value', value, typeof value)
      callback()
    }
    return {
      companyId: Lockr.get('userInfo').id,
      loading: true,
      hide: true,
      tableData: [],
      page: 1,
      totalCount: 0,
      formInlineTmp: {
        name: '',
        status: '',
        beginTime: '',
        endTime: ''
      }, // 查询参数
      formInline: {
        name: ''
      },
      limit: 10,
      adddialog: false,
      addLabelWidth: '80px',
      disabled: false,
      addForm: {
        id: '',
        name: '',
        remark: '',
        winRate: 0,
        appId: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        winRate: [
          { required: true, validator: checkWinRate, trigger: 'blur' }
        ],
        appId: [
          { required: true, message: '请选择APPID', trigger: 'blur' }
        ],
        startEnd: [
          { required: true, validator: checkStartEnd, trigger: 'blur' }
        ]
      },
      startEnd: [],
      searStartEnd: [],
      publicNumberList: [],
      butsObj: { // button按钮列表
        del: false,
        add:false,
        edit:false
      }
    }
  },
  mounted () {
    rule.publicNumber((res) => {
      for (let item of res.data.data.list) {
        this.publicNumberList.push({ label: item.nick_name, value: item.appid, qrcodeUrl: item.qrcode_url })
      }
      console.log(this.publicNumberList)
    })
  },
  computed: {
  },
  methods: {
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    getData () {
      this.loading = true
      var params = {
        companyId: this.companyId,
        pageSize: this.limit, // 页码
        pageNum: this.page,  // 条数
        beginTime: this.searStartEnd[0],
        endTime: this.searStartEnd[1],
        name: this.formInlineTmp.name,
        // appId: '', // 微信appId
      }
      getVideoActivitys(params).then(res => {
        this.tableData = res.data.result.list
        this.totalCount = res.data.result.total
      })
      this.openLoading()
    },

    searchLoad () {
      this.page = 1
      this.getData()
    },
    openDialog (saveType, row) {
      this.adddialog = true
      if (saveType == 'edit') {
        var obj = JSON.parse(JSON.stringify(row))
        this.addForm.id = obj.id
        this.addForm.name = obj.name
        this.addForm.remark = obj.remark
        this.addForm.appId = obj.appId
        this.addForm.winRate = obj.winRate
        this.startEnd = [obj.beginTime, obj.endTime]
      } else {
        this.addForm.id = ''
        this.addForm.name = ''
        this.addForm.remark = ''
        this.addForm.appId = ''
        this.addForm.winRate = ''
        this.startEnd = []
      }
    },

    saveWay () {
      if (this.addForm.id) {
        this.editVideoActivitys()
      } else {
        this.createVideoActivitys()
      }
    },


    // 添加活动
    createVideoActivitys () {
      console.log(this.startEnd)
      if (this.startEnd.length != 2) {
        _g.toastMsg('error', '请选择活动时间')
        return
      }
      if (!this.addForm.name) {
        _g.toastMsg('error', '请输入活动名称')
        return
      }
      if (!this.addForm.appId) {
        _g.toastMsg('error', '请选择APPID')
        return
      }
      var params = {
        companyId: this.companyId,
        name: this.addForm.name,
        remark: this.addForm.remark,
        appId: this.addForm.appId,
        winRate: this.addForm.winRate,
        beginTime: this.startEnd[0],
        endTime: this.startEnd[1],
        qrcodeUrl: this.filterAppId(this.addForm.appId)
      }
      createVideoActivitys(params).then(res => {
        if (res.data.code == 200) {
          this.adddialog = false
          _g.toastMsg('success', res.data.message)
          this.getData()
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 编辑
    editVideoActivitys () {
      if (this.startEnd.length != 2) {
        _g.toastMsg('error', '请选择活动时间')
        return
      }
      if (!this.addForm.name) {
        _g.toastMsg('error', '请输入活动名称')
        return
      }
      if (!this.addForm.appId) {
        _g.toastMsg('error', '请选择APPID')
        return
      }
      var params = {
        id: this.addForm.id,
        companyId: this.companyId,
        name: this.addForm.name,
        remark: this.addForm.remark,
        appId: this.addForm.appId,
        winRate: this.addForm.winRate,
        beginTime: this.startEnd[0],
        endTime: this.startEnd[1],
        qrcodeUrl: this.filterAppId(this.addForm.appId)
      }
      editVideoActivitys(params).then(res => {
        if (res.data.code == 200) {
          this.adddialog = false
          _g.toastMsg('success', res.data.message)
          this.getData()
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 删除活动
    deleteAction (id) {
      this.$confirm('确认删除该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteVideoActivitys(id).then((res) => {
          if (res.data.code == 200) {
            this.getData()
            _g.toastMsg('success', '删除成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 处理分页
    handleSizeChange (val) {
      this.limit = val
    },
    handleCurrentChange (page) {
      this.page = page
      this.getData()
    },
    copyAcivityAction (id) {
      copyAcivity(id).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          this.getData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    copyText (id) {
      // 创建range对象
      let range = document.createRange()
      // 传入需要选中的节点
      range.selectNodeContents(document.querySelector('.class' + id))
      var selection = document.getSelection()
      // 清空选中的区域
      selection.removeAllRanges()
      // 添加选中区域
      selection.addRange(range)
      // 执行复制
      document.execCommand('Copy')
      _g.toastMsg('success', '复制成功')
    },
    filterAppId (appId) {
      var result = this.publicNumberList.find(function (item, index) {
        return item.value == appId
      })
      console.log(result);
      return result.qrcodeUrl || ''
    }
  },
  created () {
    this.getButtonsList()
    this.getData()
  },
  watch: {
    'searStartEnd' (newVal) {
      if (newVal == null) {
        this.searStartEnd = []
      }
    }
  },
}
</script>

<style scoped>
.timeBox .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}

.dialog .el-input__inner {
  width: 100% !important;
}
/*.el-table .cell:empty::before{*/
/*  content:'——';*/
/*  color:gray;*/
/*}*/
</style>
